import logo from "../logo.svg";
import "../App.css";
import { useEffect } from "react";
import "../styles.css";

function Mubarrat() {
    useEffect(() => {
        // CharityStack embed — type text/javascript, defer, id charitystack-embed, data-id M_dby7G6Xtc5
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.defer = true;
        script.id = "charitystack-embed";
        script.dataset.id = "M_dby7G6Xtc5";
        script.src =
            "https://dev-donation-elements-ba-donationelementsjsfilesb-1lgdmjudjjwlq.s3.us-east-2.amazonaws.com/bundle.js";
        document.head.appendChild(script);

        const onIframeMessage = (event) => {
            if (event.data.action !== "IFRAME_LOADED") {
                return;
            }
            const data = JSON.parse(event.data.data);
            const iframeID = data.elementID;
            const iframe = document.getElementById(iframeID);

            if (!iframe) {
                console.warn(`Iframe with ID ${iframeID} not found`);
                return;
            }

            const cssContent = `                 
                #57f555bd-771f-4992-a749-65a98e5f328d-CS-fundraising-bar-pill-text-right {
                    opacity: 0 !important;
                }
                    #dcb87a10-4825-48a6-b005-970db53cf45f-CS-fundraising-bar-pill-text-right {
                    opacity: 0 !important;
                }
            `;

            iframe.contentWindow.postMessage(
                {
                    action: "ADD_CSS_CONTENT",
                    entity: "CHARITYSTACK",
                    sender: "PARENT_WEBSITE",
                    receiver: "FUNDRAISING_BAR",
                    data: cssContent,
                    id: iframeID,
                },
                "*"
            );
        };

        window.addEventListener("message", onIframeMessage);

        return () => {
            window.removeEventListener("message", onIframeMessage);
            script.remove();
        };
    }, []);

    return (
        <div className="App">
            {/* <div
                style={{
                    position: "fixed",
                    top: "0px",
                    width: "100%",
                    height: "100px",
                    background: "linear-gradient(to bottom, #0066ff, #ff0000)",
                    zIndex: "99999",
                }}></div> */}

            <div>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce
                sollicitudin enim et dolor pellentesque, et aliquam velit
                vestibulum. Morbi condimentum felis eget tortor congue, id
                convallis turpis fringilla. Duis rutrum tellus et sapien
            </div>

            <div data-entity="EMBED_FORM" data-source="CharityStack" id="5eeb7177-06ee-47ed-a0ad-df67d810f6f8"></div>

            <div data-entity="EMBED_FORM" data-source="CharityStack" id="5c29ac28-08ba-4f2b-9a6c-0b1f10efa1de"></div>

            <div data-entity="EMBED_FORM" data-source="CharityStack" id="04a1acfb-dab7-4785-b9aa-a27fb75cd310"></div>

            <div data-entity="EVENT" data-source="CharityStack" id="e58c9de5-415e-4ed5-a3ce-e43def50d3b0"></div>

        </div>
    );
}

export default Mubarrat;
